export const mediaList = [
  {
    id: "m001",
    title: "星际远征",
    type: "电影",
    region: "欧美",
    year: 2024,
    rating: 8.6,
    views: 1286000,
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%20of%20a%20lone%20astronaut%20before%20a%20glowing%20wormhole%2C%20deep%20navy%20and%20cyan%20starfield%2C%20dramatic%20rim%20lighting%2C%20epic%20scale%2C%20dark%20empty%20space%20for%20title%2C%20high%20detail%20digital%20art&width=400&height=600&seq=poster-m001&orientation=portrait",
    synopsis:
      "一支深入深空的人类探险队穿越虫洞后，发现宇宙边缘正悄然改写现实的法则。他们必须在时间耗尽前找到归途，也要面对彼此心底最深的恐惧。",
    cast: ["陈默然", "林知远", "苏晚晴", "阿德里安·科尔"],
    director: "诺兰·维斯",
    updateDate: "2024-10-12",
    tags: ["科幻", "冒险", "太空"],
  },
  {
    id: "m002",
    title: "暗夜追凶",
    type: "电影",
    region: "内地",
    year: 2024,
    rating: 8.2,
    views: 963000,
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20crime%20thriller%20film%20poster%20of%20a%20rain%20soaked%20city%20alley%20at%20night%2C%20silhouette%20of%20a%20detective%20under%20streetlight%2C%20neon%20amber%20highlights%2C%20dark%20teal%20shadows%2C%20tense%20cinematic%20atmosphere%2C%20empty%20upper%20area&width=400&height=600&seq=poster-m002&orientation=portrait",
    synopsis:
      "连环悬案沉寂七年后再掀波澜，一名被停职的老刑警与年轻女法医联手追查，真相却指向他们共同的过去。",
    cast: ["张鹤川", "周雨桐", "王立群"],
    director: "李承宇",
    updateDate: "2024-10-09",
    tags: ["悬疑", "犯罪", "剧情"],
  },
  {
    id: "m003",
    title: "长空之翼",
    type: "电影",
    region: "内地",
    year: 2023,
    rating: 7.9,
    views: 872000,
    cover:
      "https://readdy.ai/api/search-image?query=Epic%20war%20aviation%20movie%20poster%20of%20fighter%20jets%20soaring%20through%20golden%20sunset%20clouds%2C%20dramatic%20orange%20and%20steel%20blue%20sky%2C%20motion%20blur%2C%20heroic%20composition%2C%20cinematic%20lighting%2C%20space%20for%20title&width=400&height=600&seq=poster-m003&orientation=portrait",
    synopsis:
      "一支年轻的飞行编队在边境危机中临危受命，用勇气与信念守护长空。一次次的起飞，都是与命运的正面对撞。",
    cast: ["赵子昂", "林海", "许婧", "何俊峰"],
    director: "孙浩然",
    updateDate: "2024-10-05",
    tags: ["动作", "战争", "热血"],
  },
  {
    id: "m004",
    title: "时间旅人",
    type: "电影",
    region: "欧美",
    year: 2023,
    rating: 8.8,
    views: 1452000,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20sci%20fi%20film%20poster%20of%20two%20figures%20separated%20by%20a%20fractured%20clock%20face%2C%20warm%20amber%20and%20deep%20indigo%20tones%2C%20soft%20bokeh%20city%20bokeh%20lights%2C%20emotional%20cinematic%20mood%2C%20minimal%20composition&width=400&height=600&seq=poster-m004&orientation=portrait",
    synopsis:
      "物理学家意外获得穿越时间的能力，却在每一次回溯中失去一点关于爱人的记忆。他终于明白，唯一无法重来的，是当下。",
    cast: ["艾玛·斯通桥", "卢卡斯·凯恩", "索菲亚·琳"],
    director: "丹尼尔·洛克",
    updateDate: "2024-10-03",
    tags: ["科幻", "爱情", "剧情"],
  },
  {
    id: "m005",
    title: "云上之城",
    type: "电影",
    region: "日韩",
    year: 2024,
    rating: 8.1,
    views: 726000,
    cover:
      "https://readdy.ai/api/search-image?query=Fantasy%20adventure%20movie%20poster%20of%20a%20floating%20city%20among%20soft%20pastel%20clouds%2C%20tiny%20traveler%20on%20a%20rope%20bridge%2C%20warm%20peach%20and%20sky%20blue%20palette%2C%20dreamlike%20painterly%20illustration%2C%20open%20sky%20for%20title&width=400&height=600&seq=poster-m005&orientation=portrait",
    synopsis:
      "少女为寻找失踪的兄长，攀上传说中的云上之城。那里悬浮着被遗忘的记忆，也藏着一个关于世界真相的秘密。",
    cast: ["新野遥", "宫本海斗", "白石棂"],
    director: "山崎凛",
    updateDate: "2024-09-28",
    tags: ["奇幻", "冒险", "治愈"],
  },
  {
    id: "m006",
    title: "深海之约",
    type: "电影",
    region: "欧美",
    year: 2022,
    rating: 7.6,
    views: 541000,
    cover:
      "https://readdy.ai/api/search-image?query=Underwater%20adventure%20movie%20poster%20of%20a%20submarine%20descending%20into%20a%20glowing%20deep%20sea%20trench%2C%20bioluminescent%20blue%20and%20teal%20glow%2C%20rays%20of%20light%20from%20surface%2C%20mysterious%20cinematic%20atmosphere&width=400&height=600&seq=poster-m006&orientation=portrait",
    synopsis:
      "海洋科考队深入从未有人抵达的海沟，在那里发现了会发出微光的古老生命体。这一次探索，将改写人类对生命的定义。",
    cast: ["凯特·摩根", "奥利弗·雷", "汉娜·维尔"],
    director: "詹姆斯·福德",
    updateDate: "2024-09-25",
    tags: ["冒险", "科幻", "海洋"],
  },
  {
    id: "m007",
    title: "山海秘境",
    type: "电影",
    region: "内地",
    year: 2024,
    rating: 8.0,
    views: 648000,
    cover:
      "https://readdy.ai/api/search-image?query=Mythical%20Chinese%20fantasy%20movie%20poster%20of%20misty%20ancient%20mountains%20with%20a%20giant%20mystic%20beast%20silhouette%2C%20ink%20wash%20painting%20style%2C%20deep%20jade%20green%20and%20gold%20accents%2C%20ethereal%20fog%2C%20epic%20oriental%20atmosphere&width=400&height=600&seq=poster-m007&orientation=portrait",
    synopsis:
      "少年在古籍残卷中寻得通往山海秘境的入口，为拯救族人踏上征程。传说中的神兽，正等待一个愿意相信的孩子。",
    cast: ["顾青禾", "叶知秋", "陆沉舟"],
    director: "白景行",
    updateDate: "2024-10-11",
    tags: ["奇幻", "古装", "动作"],
  },
  {
    id: "t001",
    title: "长安十二时",
    type: "电视剧",
    region: "内地",
    year: 2024,
    rating: 9.1,
    views: 1854000,
    cover:
      "https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20poster%20of%20ancient%20Changan%20city%20lanterns%20at%20dusk%2C%20elegant%20figure%20in%20traditional%20robe%2C%20warm%20golden%20and%20deep%20crimson%20palette%2C%20cinematic%20period%20atmosphere%2C%20intricate%20architecture&width=400&height=600&seq=poster-t001&orientation=portrait",
    synopsis:
      "上元佳节的长安城暗流涌动，一名底层暗探在十二个时辰内卷入惊天阴谋。他要用一夜的时间，去赌一座城的安宁。",
    cast: ["萧景琰", "沈知微", "裴无咎", "温婉仪"],
    director: "陈书延",
    updateDate: "2024-10-14",
    episodes: 24,
    tags: ["古装", "悬疑", "权谋"],
  },
  {
    id: "t002",
    title: "城市之光",
    type: "电视剧",
    region: "内地",
    year: 2024,
    rating: 8.4,
    views: 1124000,
    cover:
      "https://readdy.ai/api/search-image?query=Urban%20drama%20series%20poster%20of%20a%20young%20professional%20walking%20through%20a%20modern%20city%20crosswalk%20at%20blue%20hour%2C%20warm%20window%20lights%20bokeh%2C%20cinematic%20contemporary%20mood%2C%20clean%20minimal%20composition&width=400&height=600&seq=poster-t002&orientation=portrait",
    synopsis:
      "三个来自不同世界的年轻人，在同一座城市里跌跌撞撞地长大。他们追逐梦想，也慢慢懂得，光从来都在自己身上。",
    cast: ["林一诺", "高一帆", "苏晴", "马嘉"],
    director: "周牧之",
    updateDate: "2024-10-13",
    episodes: 32,
    tags: ["都市", "剧情", "成长"],
  },
  {
    id: "t003",
    title: "迷雾侦探",
    type: "电视剧",
    region: "欧美",
    year: 2024,
    rating: 8.9,
    views: 1658000,
    cover:
      "https://readdy.ai/api/search-image?query=Detective%20mystery%20series%20poster%20of%20a%20foggy%20coastal%20town%20with%20a%20single%20figure%20holding%20a%20lantern%2C%20cool%20teal%20mist%20and%20warm%20lantern%20glow%2C%20tense%20cinematic%20atmosphere%2C%20moody%20minimal%20silhouette&width=400&height=600&seq=poster-t003&orientation=portrait",
    synopsis:
      "一场大雾笼罩的港城接连发生离奇失踪案。患有脸盲症的天才侦探，靠着一本手写的记忆笔记，拼凑出令人战栗的真相。",
    cast: ["亨利·布莱克", "艾拉·诺瓦", "托马斯·格雷"],
    director: "奥利维亚·邦德",
    updateDate: "2024-10-10",
    episodes: 10,
    tags: ["悬疑", "犯罪", "推理"],
  },
  {
    id: "t004",
    title: "破晓之战",
    type: "电视剧",
    region: "内地",
    year: 2023,
    rating: 7.8,
    views: 894000,
    cover:
      "https://readdy.ai/api/search-image?query=Action%20war%20series%20poster%20of%20soldiers%20advancing%20at%20dawn%20through%20smoke%2C%20deep%20orange%20sunrise%20and%20charcoal%20gray%20palette%2C%20dramatic%20backlit%20silhouettes%2C%20epic%20cinematic%20battlefield%20atmosphere&width=400&height=600&seq=poster-t004&orientation=portrait",
    synopsis:
      "黎明前最黑暗的时刻，一支小队接到几乎不可能完成的任务。他们彼此托付后背，在炮火中写下属于平凡人的史诗。",
    cast: ["方振宇", "谢云帆", "唐烈"],
    director: "韩慕之",
    updateDate: "2024-10-07",
    episodes: 40,
    tags: ["动作", "战争", "热血"],
  },
  {
    id: "t005",
    title: "锦绣年华",
    type: "电视剧",
    region: "内地",
    year: 2023,
    rating: 8.7,
    views: 1342000,
    cover:
      "https://readdy.ai/api/search-image?query=Period%20drama%20series%20poster%20of%20an%20elegant%20woman%20in%20embroidered%20silk%20robe%20beside%20a%20lattice%20window%2C%20soft%20rose%20and%20jade%20green%20tones%2C%20delicate%20floral%20patterns%2C%20refined%20oriental%20cinematic%20composition&width=400&height=600&seq=poster-t005&orientation=portrait",
    synopsis:
      "从绣坊学徒到一代名匠，她用一针一线绣出了自己的人生。乱世沉浮里，柔软也可以是最坚韧的力量。",
    cast: ["陆明萱", "裴景辰", "宁妃"],
    director: "顾婉清",
    updateDate: "2024-10-06",
    episodes: 36,
    tags: ["古装", "剧情", "传奇"],
  },
  {
    id: "t006",
    title: "未来纪元",
    type: "电视剧",
    region: "日韩",
    year: 2024,
    rating: 8.5,
    views: 1086000,
    cover:
      "https://readdy.ai/api/search-image?query=Cyberpunk%20sci%20fi%20series%20poster%20of%20a%20futuristic%20neon%20skyline%20with%20a%20lone%20hacker%20silhouette%2C%20magenta%20and%20cyan%20neon%20accents%2C%20rain%20slick%20streets%2C%20high%20tech%20cinematic%20atmosphere&width=400&height=600&seq=poster-t006&orientation=portrait",
    synopsis:
      "在一个被算法支配的未来城市，记忆可以被买卖。一个普通快递员意外获得一段不属于他的记忆，从此卷入改变世界的漩涡。",
    cast: ["井上翔", "高桥真央", "小林悠真"],
    director: "佐藤健吾",
    updateDate: "2024-10-08",
    episodes: 12,
    tags: ["科幻", "悬疑", "赛博"],
  },
  {
    id: "t007",
    title: "无声告白",
    type: "电视剧",
    region: "日韩",
    year: 2023,
    rating: 8.3,
    views: 762000,
    cover:
      "https://readdy.ai/api/search-image?query=Romantic%20melodrama%20series%20poster%20of%20two%20young%20people%20standing%20apart%20in%20light%20rain%2C%20soft%20muted%20blue%20and%20warm%20gray%20tones%2C%20gentle%20bokeh%2C%20tender%20melancholic%20cinematic%20mood&width=400&height=600&seq=poster-t007&orientation=portrait",
    synopsis:
      "听障女孩与失意的钢琴调音师相遇，两个不完整的人慢慢学会用沉默倾听彼此。有些告白，不必说出口。",
    cast: ["尹夏恩", "朴时厚", "韩素琳"],
    director: "郑敏浩",
    updateDate: "2024-10-04",
    episodes: 16,
    tags: ["爱情", "剧情", "治愈"],
  },
  {
    id: "v001",
    title: "星光大冒险",
    type: "综艺",
    region: "内地",
    year: 2024,
    rating: 7.4,
    views: 684000,
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20variety%20show%20poster%20of%20a%20festive%20outdoor%20stage%20with%20colorful%20lights%20and%20confetti%2C%20energetic%20young%20crowd%2C%20vibrant%20orange%20and%20teal%20palette%2C%20playful%20joyful%20atmosphere%2C%20clean%20upper%20space&width=400&height=600&seq=poster-v001&orientation=portrait",
    synopsis:
      "八位明星嘉宾踏上星河之旅，在陌生城市完成一场场爆笑又暖心的挑战。每一次出发，都是意料之外的惊喜。",
    cast: ["主持群星", "飞行嘉宾"],
    director: "李欢",
    updateDate: "2024-10-12",
    episodes: 12,
    tags: ["真人秀", "竞技", "搞笑"],
  },
  {
    id: "v002",
    title: "味觉之旅",
    type: "综艺",
    region: "内地",
    year: 2024,
    rating: 8.0,
    views: 561000,
    cover:
      "https://readdy.ai/api/search-image?query=Food%20documentary%20variety%20poster%20of%20a%20rustic%20wooden%20table%20filled%20with%20steaming%20regional%20dishes%2C%20warm%20amber%20and%20terracotta%20tones%2C%20soft%20natural%20light%2C%20appetizing%20editorial%20food%20photography&width=400&height=600&seq=poster-v002&orientation=portrait",
    synopsis:
      "跟着镜头走遍大江南北，寻找藏在街巷与灶台间的烟火滋味。每一道菜背后，都有一个关于家的故事。",
    cast: ["美食向导团"],
    director: "陈味",
    updateDate: "2024-10-09",
    episodes: 10,
    tags: ["美食", "纪实", "治愈"],
  },
  {
    id: "v003",
    title: "音乐狂想曲",
    type: "综艺",
    region: "内地",
    year: 2023,
    rating: 7.7,
    views: 472000,
    cover:
      "https://readdy.ai/api/search-image?query=Music%20competition%20show%20poster%20of%20a%20glowing%20concert%20stage%20with%20a%20microphone%20and%20spotlights%2C%20rich%20violet%20and%20amber%20stage%20lighting%2C%20energetic%20crowd%20bokeh%2C%20dramatic%20live%20performance%20mood&width=400&height=600&seq=poster-v003&orientation=portrait",
    synopsis:
      "素人与专业歌手同台竞演，用一首歌的时间打动全场。舞台之上，没有小人物，只有还没被听见的声音。",
    cast: ["音乐评审团", "竞演歌手"],
    director: "王律",
    updateDate: "2024-10-02",
    episodes: 14,
    tags: ["音乐", "竞演", "真人秀"],
  },
  {
    id: "v004",
    title: "极限挑战营",
    type: "综艺",
    region: "日韩",
    year: 2024,
    rating: 7.2,
    views: 413000,
    cover:
      "https://readdy.ai/api/search-image?query=Adventure%20reality%20show%20poster%20of%20contestants%20crossing%20a%20wooden%20obstacle%20course%20in%20a%20forest%2C%20bright%20green%20and%20warm%20orange%20accent%20tones%2C%20dynamic%20action%20mood%2C%20daylight%20outdoor%20cinematic&width=400&height=600&seq=poster-v004&orientation=portrait",
    synopsis:
      "来自各地的挑战者组成临时小队，在荒野中完成层层关卡。体力、智力与默契的极限碰撞，谁能笑到最后？",
    cast: ["挑战主持团", "素人挑战者"],
    director: "金泰勋",
    updateDate: "2024-10-01",
    episodes: 16,
    tags: ["真人秀", "户外", "竞技"],
  },
];